export default __webpack_public_path__ + "static/img6-ec9b87a2268c58a72a0c35ec83cba1eb.jpg";